import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export type GetUserActivityParams = {
  id: string;
  page: number;
  pageSize: number;
};

export interface UserActivityItem {
  tenant_id: string;
  id: string;
  user_id: string;
  description: string;
  timestamp: Date;
  ip_address?: string | null;
  user_agent?: string | null;
  metadata?: object | null;
}

export type GetUserActivityResult = {
  rows: UserActivityItem[];
  count: number;
} | null;

async function getUserActivity(params: GetUserActivityParams): Promise<GetUserActivityResult | null> {
  if (!params.id) {
    return null;
  }

  // make api call
  const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/users/${params.id}/activity`, {
    params: {
      page: params.page,
      pageSize: params.pageSize,
    },
  });

  // return the data object
  return result.data as GetUserActivityResult;
}

const useGetUserActivity = createQuery<GetUserActivityResult, GetUserActivityParams, AxiosError<ErrorResponse>>({
  queryKey: ['user_activity'],
  fetcher: (variables) => getUserActivity(variables),
});

export { useGetUserActivity };
